module.exports = __webpack_public_path__ + "img/hair_front_female_very_short.58ae3b52.png";